const Variables = {
    domainName : "http://82.180.154.136:3002",
}

export default Variables